export default "__VITE_ASSET__Bn44gPK5__"